import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import './App.css';

// Components
import Header from './components/Header';
import Hero from './components/Hero';
import WhatWeDo from './components/WhatWeDo';
import HowItWorks from './components/HowItWorks';
import RevenueModel from './components/RevenueModel';
import Tools from './components/Tools';
import FitCheck from './components/FitCheck';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import ApplicationForm from './components/ApplicationForm';
import Footer from './components/Footer';
import ConfirmationPage from './components/ConfirmationPage';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleFormSubmit = (formData) => {
    console.log('Application submitted:', formData);
    // Navigate to confirmation page
    navigate('/confirmation');
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-16">
        <Hero />
        <WhatWeDo />
        <HowItWorks />
        <RevenueModel />
        <Tools />
        <FitCheck />
        <FAQ />
        <FinalCTA />
        <ApplicationForm onSubmit={handleFormSubmit} />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/confirmation" element={<ConfirmationPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
